import { useEffect, useState } from 'react';
import debounce from "lodash/debounce";
export const useBreakpoint = () => {
    const getBreakpoint = () => {
        const width = window.innerWidth;
        if (width < 768)
            return 'mobile';
        // Inclusive so it matches the SCSS `tabletAndBelow` mixin (max-width: 1024px)
        if (width <= 1024)
            return 'tablet';
        return 'desktop';
    };
    const isSSR = typeof window === 'undefined';
    const [breakpoint, setBreakpoint] = useState(isSSR ? 'desktop' : getBreakpoint());
    useEffect(() => {
        const handleResize = debounce(() => {
            const current = getBreakpoint();
            setBreakpoint((prev) => (prev !== current ? current : prev));
        }, 100);
        window.addEventListener('resize', handleResize);
        return () => {
            handleResize.cancel();
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return {
        isMobile: breakpoint === 'mobile',
        isTablet: breakpoint === 'tablet',
        isDesktop: breakpoint === 'desktop',
    };
};
